<div
  class="sb-container"
  kendoDialogContainer
  *ngIf="{ solutionTypes: solutionTypes$ | async } as data"
>
  <div #spacer></div>
  <header class="sb-header" stickyThing [spacer]="spacer">
    <div class="grid-x">
      <div class="small-7 cell">
        <ul class="sb-tab-menu">
          <li>
            <a class="is-active">Solution Types</a>
          </li>
        </ul>
      </div>

      <div class="small-5 cell align-self-middle"></div>
    </div>
  </header>
  <main class="sb-content">
    <!-- Page Header Section-->
    <header class="sb-content-header">
      <div class="grid-x align-middle">
        <div class="small-8 cell">
          <ul class="sb-breadcrumbs">
            <li class="is-parent"><span>Solution Builder</span></li>
            <li class="is-divider"><span>/</span></li>
            <li class="is-parent"><a [routerLink]="'/admin'">Settings</a></li>
            <li class="is-divider"><span>/</span></li>
            <li class="is-active"><span class="">Solution Types</span></li>
          </ul>
          <h1 class="sb-content-heading">Solution Types</h1>
        </div>
        <div class="small-4 cell text-right">
          <button [routerLink]="['./-1']" kendoButton primary="true">
            Create New
          </button>
        </div>
      </div>
    </header>
    <!-- Template List Section-->
    <section class="sb-flow-list-section">
      <div class="grid-x">
        <div class="cell">
          <div class="sb-flow-item-list">
            <sb-callout *ngIf="data.solutionTypes?.length === 0" warn="true"
              >No Solution Types found.</sb-callout
            >
            <div class="grid-x">
              <div
                class="small-12 cell"
                *ngFor="let item of data.solutionTypes; index as i"
              >
                <div class="sb-flow-item-wrapper">
                  <div
                    class="sb-flow-item"
                    [class.is-selected]="item.isSelected"
                    kendoTooltip
                  >
                    <div class="sb-flow-item-content">
                      <span
                        class="sb-flow-item-name"
                        [attr.title]="item.name"
                        >{{ item.name }}</span
                      >
                    </div>
                    <div class="sb-flow-actions">
                      <button
                        kendoButton
                        primary="true"
                        [routerLink]="['./' + item.id]"
                      >
                        Edit
                      </button>
                      <button
                        kendoButton
                        (click)="confirmRemoveSolutionType(item)"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</div>
